<div class="drawer lg:drawer-open">
  <input
    id="aside-drawer"
    type="checkbox"
    class="drawer-toggle"
    [(ngModel)]="showDrawer"
  />
  <div class="drawer-content flex flex-col">

    <!-- Navbar -->
    <app-nav-top-secure (toggleDrawer)="toggleDrawer()"></app-nav-top-secure>

    <!-- Page content here -->
    <router-outlet></router-outlet>

  </div>
  <div
    class="drawer-side"
    style="scroll-behavior: smooth; scroll-padding-top: 5rem"
  >
    <label
      for="aside-drawer"
      aria-label="close sidebar"
      class="drawer-overlay"
    ></label>
    <aside class="bg-base-100 min-h-screen w-80">
      <div
        class="bg-base-100 sticky top-0 z-20 hidden items-center gap-2 bg-opacity-90 px-4 py-2 backdrop-blur lg:flex"
      >
        <app-aside-header></app-aside-header>
      </div>
      <app-nav-aside [pt]="'pt-4'" [dataUrl]="environment.api.data.navigation"></app-nav-aside>
    </aside>
  </div>
</div>
